angular.module('cian.mapDraw').factory('MapDrawService', ['$http', $http => ({
  getScheme: region_id => $http.get('/ajax/search/metro/' + region_id + '/', {cache: true})
})]);


// WEBPACK FOOTER //
// ./src/components/map-draw/src/scripts/cian.map-draw.service.js